/* ==========================================================================
   #197 / #231 — La fila de colecciones que se pega (antes inline en
   sections/header.liquid). Externalizado a asset cacheable: 0 tags Liquid,
   solo lee el DOM. Con defer corre tras el parseo completo, que para un
   conmutador de scroll es incluso mas correcto que el parse-time original.
   ========================================================================== */
  (function () {
    'use strict';

    function plantillaPropia() {
      var c = document.body && document.body.classList;
      return !!c && (c.contains('template-index') || c.contains('template-product'));
    }
    if (!plantillaPropia()) return;

    var seccion = null;         // .shopify-section-header
    var filaColecciones = null; // #nav — la fila que se queda a la vista en escritorio
    var espaciador = null;      // .mi-fila-hueco, insertado justo despues de la seccion

    var pegada = false;
    var anchoVentana = window.innerWidth;
    var diagnosticoResize = { revision: 'alto-estable-1', alturaIgnorada: 0, remediciones: 0 };
    window.__miFilaResize = diagnosticoResize;

    /* Medido EN REPOSO (con la seccion todavia en flujo). Se congela al fijar
       y se vuelve a leer al soltar — igual que `altoEnFlujo` en `mi-nav.js`,
       y por la misma razon: con la seccion ya fija su propio rect deja de
       describir donde estaria en el flujo. */
    var topDoc = 0;     // top de la seccion en el DOCUMENTO, en reposo
    var oculto = 0;     // cuanto hay que esconder para que solo asome la fila
    var altoFlujo = 0;  // alto total de la seccion en reposo == el hueco

    /* HISTERESIS DE 12px ENTRE ENCENDER Y APAGAR.
       Sin ella, un scroll de un solo pixel justo en el umbral (una rueda
       lenta, un trackpad) conmutaria la clase en cada fotograma. No se veria
       como un parpadeo visual —las dos posiciones coinciden en pantalla, ese
       es todo el punto del mecanismo— pero es reflujo de layout gratis en
       cada frame. Con el margen hay que cruzar 12px de vuelta para apagar, y
       ese margen ya no se cruza sin querer. */
    var HISTERESIS = 12;

    function movil() {
      return window.matchMedia('(max-width: 1199px)').matches;
    }

    /* Se MIDE, no se supone: si el logo cambia de tamaño o el editor mueve un
       bloque, el desplazamiento se ajusta solo en la siguiente pasada. */
    function medir() {
      if (!seccion || pegada) return; // con la seccion fija el rect no es de fiar
      var r = seccion.getBoundingClientRect();
      topDoc = Math.round(r.top + window.scrollY);
      altoFlujo = Math.round(r.height);

      if (!movil() && filaColecciones) {
        /* La distancia del borde superior de la SECCION al de `#nav`: eso es
           exactamente lo que hay que esconder para que `#nav` quede en 0. */
        oculto = Math.max(0, Math.round(filaColecciones.getBoundingClientRect().top - r.top));
      } else {
        /* En movil `#nav` es el cajon —fixed, fuera de flujo— y no hay fila
           de logo que esconder: la que se ve pegada es la barra compacta
           entera, que ya empieza justo donde empieza la seccion. */
        oculto = 0;
      }

      seccion.style.setProperty('--mi-fila-oculto', oculto + 'px');
    }

    function crearEspaciador() {
      if (espaciador && espaciador.parentNode === seccion.parentNode) return espaciador;
      espaciador = document.createElement('div');
      espaciador.className = 'mi-fila-hueco';
      espaciador.setAttribute('aria-hidden', 'true');
      seccion.parentNode.insertBefore(espaciador, seccion.nextSibling);
      return espaciador;
    }

    function fijar() {
      if (pegada || !seccion) return;
      crearEspaciador();
      /* El espaciador se dimensiona ANTES de fijar la seccion, en el mismo
         turno: nunca hay un fotograma con la seccion ya fija y el hueco
         todavia en 0 — que es justo el instante en el que el documento
         perderia altura y el contenido saltaria hacia arriba. */
      espaciador.style.height = altoFlujo + 'px';
      pegada = true;
      seccion.classList.add('mi-fila-pegada');
    }

    function soltar() {
      if (!pegada) return;
      pegada = false;
      seccion.classList.remove('mi-fila-pegada');
      if (espaciador) espaciador.style.height = '0px';
      medir(); // ya se puede confiar otra vez en el rect
    }

    function evaluar() {
      if (!seccion) return;
      var umbral = topDoc + oculto;
      if (!pegada && window.scrollY >= umbral) fijar();
      else if (pegada && window.scrollY <= umbral - HISTERESIS) soltar();
    }

    var pendiente = 0;
    function programar() {
      if (pendiente) return;
      pendiente = requestAnimationFrame(function () {
        pendiente = 0;
        if (!pegada) medir();
        evaluar();
      });
    }

    function remedirCompleto() {
      diagnosticoResize.remediciones++;
      /* Un resize puede cruzar el corte movil/escritorio (1199px), y con el
         cambia CUAL es la fila que hay que esconder (la de colecciones o la
         barra del logo). Se suelta primero para medir en limpio: medir con
         la seccion todavia fija leeria el rect equivocado. */
      var estabaFija = pegada;
      if (estabaFija) soltar();
      medir();
      evaluar();
    }

    function alCambiarVentana() {
      var anchoActual = window.innerWidth;
      var mismoAncho = anchoActual === anchoVentana;
      anchoVentana = anchoActual;
      /* Safari cambia innerHeight mientras anima su barra de direcciones.
         Eso NO cambia el ancho ni el alto de esta cabecera. Soltar/fijar
         aqui sacaba y devolvia la cabecera al flujo, con lecturas de layout
         entre ambos pasos, durante el desplazamiento vertical del iPhone.
         Con 20 resizes sin cambio de ancho se midieron 40 mutaciones de
         mi-fila-pegada. En movil se ignora solo ese caso; siguen activos el
         cambio de ancho, orientacion, fuentes, editor y ResizeObserver.
         El comportamiento de escritorio se conserva. */
      if (anchoActual <= 809 && mismoAncho) {
        diagnosticoResize.alturaIgnorada++;
        return;
      }
      remedirCompleto();
    }

    function localizarNodos() {
      seccion = document.querySelector('.shopify-section-header');
      if (!seccion) return false;
      filaColecciones = seccion.querySelector('#nav');
      espaciador = seccion.parentNode ? seccion.parentNode.querySelector('.mi-fila-hueco') : null;
      return true;
    }

    function arrancar() {
      pegada = false;
      if (!localizarNodos()) return;
      medir();
      evaluar();

      /* Dos repasos tardios, igual que `mi-nav.js`: el logo o el buscador
         pueden reajustar su alto una vez la fuente web ya cargo. */
      setTimeout(remedirCompleto, 350);
      setTimeout(remedirCompleto, 1200);

      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          if (!pegada) medir();
        }).observe(seccion);
      }
    }

    window.addEventListener('scroll', programar, { passive: true });
    window.addEventListener('resize', alCambiarVentana, { passive: true });
    window.addEventListener('orientationchange', remedirCompleto, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(remedirCompleto).catch(function () {});
    }

    // El editor de temas vuelve a pintar la seccion: hay que reenganchar todo.
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('shopify-section-header')) {
        arrancar();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrancar);
    } else {
      arrancar();
    }
  })();
